export function normaliseMarketName(name: string) {
	const lower = name.toLocaleLowerCase()
	// we have some country names that are different between the map deployments and the geojson we use for the map, so we need to normilise them here so that they match and the filters work correctly
	if (lower === 'usa') {
		return 'United States of America'
	}
	if (lower.includes('united states')) {
		return 'United States of America'
	}
	if (lower === 'uk') return 'United Kingdom'
	return name
}

export function normaliseCountryCode(code: string) {
	const upper = code.toLocaleUpperCase()
	if (upper === 'UK') return 'GB'
	return code
}
